import { FilterValue } from '../types/filter-value';
import { SearchState } from '../types/search-state';
import { buildFiltersObjectFromFiltersArray } from './build-filters-object-from-filters-array';
import { buildSearchStateFilters } from './build-search-state-filters';

export const buildFiltersArrayFromFiltersObject = (
  facetType: string,
  filterValue: FilterValue,
  filtersArray: SearchState['filter'],
) => {
  const filtersObject = buildFiltersObjectFromFiltersArray(
    filtersArray as string[][],
  );

  const facetTypeFilters = filtersObject[facetType];

  if (Array.isArray(filterValue)) {
    const hasEvery = (facetTypeFilters as string[])
      ?.flat(1)
      .every(filter => filterValue.some(filterValue => filter === filterValue));

    if (hasEvery) {
      delete filtersObject[facetType];
    } else {
      filtersObject[facetType] = filterValue as string[];
    }
  } else {
    if (facetTypeFilters) {
      if (facetTypeFilters.indexOf(filterValue as string) > -1) {
        facetTypeFilters.splice(
          facetTypeFilters.indexOf(filterValue as string),
          1,
        );
      } else {
        (facetTypeFilters as string[]).push(filterValue as string);
      }
    } else {
      filtersObject[facetType] = [filterValue as string];
    }
  }

  const arrayOfFilters = buildSearchStateFilters(
    filtersObject as { [key: string]: string[] },
  );

  return arrayOfFilters;
};
